import { Box } from "@mui/material"
import type { FC } from "react"

import { ACCOUNT_BALANCE_LABELS, ACCOUNT_CLASSIFICATION_LABELS, REPORTING_ACCOUNT_TYPE_LABELS } from "../constants"

import type { GlAccount } from "@/graphql/codegen/graphql"
import { ReportingAccountType } from "@/graphql/codegen/graphql"
import { AccountDetailsField } from "@/screens/Accounting/components/AccountDetailsField"

interface AccountDetailsRowProps {
  account: GlAccount
}

export const AccountDetailsRow: FC<AccountDetailsRowProps> = ({ account }) => {
  // Determine reporting account type: if has parent, it's a posting account; otherwise, it's a parent account
  const reportingAccountType = account.parentGlAccountId ? ReportingAccountType.Posting : ReportingAccountType.Parent

  return (
    <Box className='grid grid-cols-2 gap-x-12 gap-y-4 bg-white p-6 md:grid-cols-3'>
      <AccountDetailsField label='Description' value={account.description || "-"} />
      <AccountDetailsField
        label='Classification'
        value={account.classification ? ACCOUNT_CLASSIFICATION_LABELS[account.classification] : "-"}
      />
      <AccountDetailsField label='Currency' value={account.currency} />
      <AccountDetailsField
        label='Normal Balance'
        value={account.balance ? ACCOUNT_BALANCE_LABELS[account.balance] : "-"}
      />
      <AccountDetailsField label='Cost Center' value={account.costCenter || "-"} />
      <AccountDetailsField
        label='Reporting Account Type'
        value={reportingAccountType ? REPORTING_ACCOUNT_TYPE_LABELS[reportingAccountType] : "-"}
      />
    </Box>
  )
}
